import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal, Tag } from "antd";

const VideoCommunication : React.FC = () => {
    const {t} = useTranslation()

    return(
        <>
            <div className="py-5">
                <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-4 rounded-md p-2 pl-3 border-l-8 border-solid border-blue-500 bg-[#F7F7F7]">
                        <div className="flex justify-between items-center">
                            <div className="h3 text-[#969696]">Dushanba, 13-avgust, 2024-yil</div>
                            <Tag color="blue">Hali boshlanmadi</Tag>
                        </div>
                        <h3 className="font-semibold my-2">Hujjatlar bo'yicha video uchrashuv</h3>
                        <p>Bu video uchrashuvda to'plangan hujjatlar bo'yicha suhbat bo'lib o'tadi va suhbat davomida hujjatlardagi kamchiliklar bartaraf etiladi.</p>
                        <div className="flex justify-between items-center my-2">
                            <span><span className="text-[#969696]">Davomiyligi:</span> <span className="font-medium">10:30-12:30</span></span>
                            <Link to={''} className="text-blue-400">Suhbat havolasi</Link>
                        </div>
                        <span className="text-end block">Yaratuvchi: Zayliddinov I (Yurist)</span>
                    </div>

                    <div className="col-span-4 rounded-md p-2 pl-3 border-l-8 border-solid border-red-500 bg-[#F7F7F7]">
                        <div className="flex justify-between items-center">
                            <div className="h3 text-[#969696]">Dushanba, 13-avgust, 2024-yil</div>
                            <Tag color="red">Vaqti tugagan</Tag>
                        </div>
                        <h3 className="font-semibold my-2">Hujjatlar bo'yicha video uchrashuv</h3>
                        <p>Bu video uchrashuvda to'plangan hujjatlar bo'yicha suhbat bo'lib o'tadi va suhbat davomida hujjatlardagi kamchiliklar bartaraf etiladi.</p>
                        <div className="flex justify-between items-center my-2">
                            <span><span className="text-[#969696]">Davomiyligi:</span> <span className="font-medium">10:30-12:30</span></span>
                            <Link to={''} className="text-blue-400">Suhbat havolasi</Link>
                        </div>
                        <span className="text-end block">Yaratuvchi: Zayliddinov I (Yurist)</span>
                    </div>

                    <div className="col-span-4 rounded-md p-2 pl-3 border-l-8 border-solid border-blue-500 bg-[#F7F7F7]">
                        <div className="flex justify-between items-center">
                            <div className="h3 text-[#969696]">Dushanba, 13-avgust, 2024-yil</div>
                            <Tag color="blue">Hali boshlanmadi</Tag>
                        </div>
                        <h3 className="font-semibold my-2">Hujjatlar bo'yicha video uchrashuv</h3>
                        <p>Bu video uchrashuvda to'plangan hujjatlar bo'yicha suhbat bo'lib o'tadi va suhbat davomida hujjatlardagi kamchiliklar bartaraf etiladi.</p>
                        <div className="flex justify-between items-center my-2">
                            <span><span className="text-[#969696]">Davomiyligi:</span> <span className="font-medium">10:30-12:30</span></span>
                            <Link to={''} className="text-blue-400">Suhbat havolasi</Link>
                        </div>
                        <span className="text-end block">Yaratuvchi: Zayliddinov I (Yurist)</span>
                    </div>

                    <div className="col-span-4 rounded-md p-2 pl-3 border-l-8 border-solid border-red-500 bg-[#F7F7F7]">
                        <div className="flex justify-between items-center">
                            <div className="h3 text-[#969696]">Dushanba, 13-avgust, 2024-yil</div>
                            <Tag color="red">Vaqti tugagan</Tag>
                        </div>
                        <h3 className="font-semibold my-2">Hujjatlar bo'yicha video uchrashuv</h3>
                        <p>Bu video uchrashuvda to'plangan hujjatlar bo'yicha suhbat bo'lib o'tadi va suhbat davomida hujjatlardagi kamchiliklar bartaraf etiladi.</p>
                        <div className="flex justify-between items-center my-2">
                            <span><span className="text-[#969696]">Davomiyligi:</span> <span className="font-medium">10:30-12:30</span></span>
                            <Link to={''} className="text-blue-400">Suhbat havolasi</Link>
                        </div>
                        <span className="text-end block">Yaratuvchi: Zayliddinov I (Yurist)</span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default VideoCommunication